import React from 'react'
// components
import DetailsForm from './components/DetailsForm'
import PlanLinks from 'components/Modals/PlanItems/components/PlanLinks'
import AdditionalModalActions from 'components/Modals/PlanItems/components/AdditionalModalActions'
// context
import { KPIContext } from 'context'
import { DetailsModalActionsContext } from 'containers/MinimizedObjectivesList/layers/Business/DetailsModalActions'
// hocs
import { withDropzone } from 'hocs'
// hooks
import { useInitialValues } from 'hooks/useInitialValues'
// constants
import { ENTITIES, Forms } from 'constants/index'
// graphql
import { PLAN_KPI_DETAILS_QUERY } from 'graphql/planKPIs/queries'
// views
import { DetailsSectionWrapper as Wrapper } from 'components/Modals/PlanItems/styles'

const DetailsSection = ({ hideModal, isFullModal, modalData, isReadOnly, form = Forms.KPI_DETAILS_FORM }) => {
  const { entity, plan, handleDetailsSubmit, getInitialValues } = React.useContext(KPIContext)
  const { shouldShowModalActions } = React.useContext(DetailsModalActionsContext)

  const initialValues = useInitialValues(getInitialValues, entity)

  return (
    <Wrapper $isFullModal={isFullModal} $shouldShowModalActions={shouldShowModalActions}>
      <DetailsForm
        form={form}
        isReadOnly={isReadOnly}
        initialValues={initialValues}
        key={entity.id}
        onSubmit={handleDetailsSubmit}
      />
      <PlanLinks
        entity={entity}
        disabled={isReadOnly || plan.locked}
        query={PLAN_KPI_DETAILS_QUERY}
        variables={{
          filter: {
            ids: [entity.id]
          }
        }}
      />
      {shouldShowModalActions && !isReadOnly && (
        <AdditionalModalActions
          entity={{ ...entity, entityType: ENTITIES.PLAN_KPI, planId: plan.id }}
          hideModal={hideModal}
          isSubPlan={modalData.isSubPlan}
          plan={modalData.parentPlan}
          sourceItems={modalData.sourceItems}
        />
      )}
    </Wrapper>
  )
}

export default withDropzone(DetailsSection)
